





document.addEventListener('DOMContentLoaded', function () {
    // Hide all data boxes initially
    var allDataBoxes = document.querySelectorAll('.data-box');
    allDataBoxes.forEach(function (box) {
        box.style.display = 'none';
    });

    // JavaScript function to toggle the data box
    function toggleBox(item) {
        var dataBox = document.getElementById(item + 'DataBox');

        // Check the current display state and toggle accordingly
        if (dataBox.style.display === 'none' || dataBox.style.display === '') {
            // Close all other data boxes
            allDataBoxes.forEach(function (box) {
                if (box !== dataBox) {
                    box.style.display = 'none';
                }
            });

            // Show the selected data box
            dataBox.style.display = 'block';
        } else {
            // Toggle off the selected data box
            dataBox.style.display = 'none';
        }
    }

    // Attach click event listeners to anchor tags
    var anchorTags = document.querySelectorAll('.size-section a');
    anchorTags.forEach(function (anchor) {
        anchor.addEventListener('click', function (event) {
            event.preventDefault(); // Prevent the default behavior of anchor tags
            var itemName = this.getAttribute('data-item');
            toggleBox(itemName);
        });
    });

    // Attach click event listeners to data boxes to close them
    var dataBoxes = document.querySelectorAll('.data-box');
    dataBoxes.forEach(function (box) {
        box.addEventListener('click', function () {
            // Hide the clicked data box
            this.style.display = 'none';
        });
    });
});



// let isFormRelative = false;

// function handleProductFormScroll() {
//   const productForm = document.querySelector('.product-form');
//   const productFormButtons = document.querySelector('.product-form__buttons');
  
//   const productFormPosition = productForm.getBoundingClientRect().top;
//   const windowHeight = window.innerHeight;

//   if (productFormPosition < windowHeight && !isFormRelative) {
//     productFormButtons.style.position = 'relative';
//     isFormRelative = true;
//   } else if (productFormPosition >= windowHeight && isFormRelative) {
//     productFormButtons.style.position = 'fixed';
//     isFormRelative = false;
//   }
// }

// window.addEventListener('scroll', handleProductFormScroll);

